import React from 'react';

/**
 * Issue 117 — multi-select category filter (empty selection = all categories).
 */
export default function CategoryMultiSelect({ categories = [], selected = [], onChange }) {
  const selectedSet = new Set(selected);
  // Issue 182: entries may be plain strings or { category, provider_name }
  // objects (customer categories endpoint). Selection values stay plain names.
  const entries = categories.map((c) =>
    typeof c === 'string' ? { category: c, provider_name: '' } : c
  );
  const toggle = (cat) => {
    if (selectedSet.has(cat)) {
      onChange(selected.filter((c) => c !== cat));
    } else {
      onChange([...selected, cat]);
    }
  };

  return (
    <div>
      <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px', fontWeight: '500' }}>
        Categories
      </label>
      <div
        style={{
          maxHeight: '160px',
          overflowY: 'auto',
          border: '1px solid #d1d5db',
          borderRadius: '6px',
          padding: '8px',
          background: '#fff',
        }}
      >
        {entries.length === 0 ? (
          <div style={{ fontSize: '13px', color: '#6b7280' }}>No categories</div>
        ) : (
          entries.map((e) => (
            <label
              key={e.provider_name ? `${e.category}__${e.provider_name}` : e.category}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                fontSize: '13px',
                padding: '3px 0',
                cursor: 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={selectedSet.has(e.category)}
                onChange={() => toggle(e.category)}
              />
              <span>{e.category}</span>
              {e.provider_name ? (
                <span
                  style={{
                    fontSize: '11px',
                    color: '#0ea5e9',
                    background: '#f0f9ff',
                    border: '1px solid #bae6fd',
                    borderRadius: '4px',
                    padding: '0 6px',
                    marginLeft: 'auto',
                    whiteSpace: 'nowrap',
                  }}
                  title={`Provider: ${e.provider_name}`}
                >
                  {e.provider_name}
                </span>
              ) : null}
            </label>
          ))
        )}
      </div>
      <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '6px', display: 'flex', gap: '10px', alignItems: 'center' }}>
        <span>{selected.length === 0 ? 'All categories' : `${selected.length} selected`}</span>
        {selected.length > 0 && (
          <button
            type="button"
            onClick={() => onChange([])}
            style={{
              background: 'none',
              border: 'none',
              color: '#0ea5e9',
              cursor: 'pointer',
              padding: 0,
              fontSize: '12px',
              textDecoration: 'underline',
            }}
          >
            Clear
          </button>
        )}
      </div>
    </div>
  );
}
